import { Type } from "discover.medical.react-component-library";
import styled from "styled-components";

export const StyledNoDataBanner = styled(Type)`
  font-style: italic;
`;

export const StyledList = styled.ul`
  margin-top: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.gray800};
  word-break: break-word;
  hyphens: auto;
  ul {
    margin-top: 0;
    margin-left: ${({ theme }) => theme.space.xl};
  }
`;
